import { apiClient } from '@/lib/api'
import type {
  Conversation,
  Message,
  MessageTemplate,
  SendMessageBody,
  TemplateWriteBody,
} from '@/types/messaging'

export const fetchConversations = async (): Promise<Conversation[]> =>
  apiClient<Conversation[]>('/messaging/conversations')

export const fetchConversation = async (customerId: string): Promise<Message[]> =>
  apiClient<Message[]>('/messaging/messages', { params: { customer_id: customerId } })

export const sendMessage = async (body: SendMessageBody): Promise<Message> =>
  apiClient<Message>('/messaging/messages', { method: 'POST', body })

export const fetchTemplates = async (): Promise<MessageTemplate[]> =>
  apiClient<MessageTemplate[]>('/messaging/templates')

export const createTemplate = async (body: TemplateWriteBody): Promise<MessageTemplate> =>
  apiClient<MessageTemplate>('/messaging/templates', { method: 'POST', body })

export const updateTemplate = async (
  id: string,
  body: TemplateWriteBody,
): Promise<MessageTemplate> =>
  apiClient<MessageTemplate>(`/messaging/templates/${id}`, { method: 'PUT', body })

export const deleteTemplate = async (id: string): Promise<void> =>
  apiClient<void>(`/messaging/templates/${id}`, { method: 'DELETE' })
